<script lang="ts">
  import { CirclePlusIcon, FileIcon, RulerIcon } from '@lucide/svelte'
  import i18n from '../../i18n'
  import Modal from '../modal/Modal.svelte'

  type Props = {
    isOpen?: boolean
  }

  let { isOpen = $bindable() }: Props = $props()
</script>

<Modal bind:open={isOpen} title={$i18n.t('project.positioningAssistant.title')}>
  {#snippet body()}
    <p class="description">
      {$i18n.t('project.positioningAssistant.steps.introduction.description')}
    </p>
    <div class="steps">
      <div class="step-item">
        <FileIcon style="flex-shrink: 0;" size={18} />
        <p>
          {$i18n.t(
            'project.positioningAssistant.steps.introduction.instructions1',
          )}
        </p>
      </div>
      <div class="step-item">
        <CirclePlusIcon style="flex-shrink: 0;" size={18} />
        <p>
          {$i18n.t(
            'project.positioningAssistant.steps.introduction.instructions2',
          )}
        </p>
      </div>
      <div class="step-item">
        <RulerIcon style="flex-shrink: 0; " size={18} />
        <p>
          {$i18n.t(
            'project.positioningAssistant.steps.introduction.instructions3.description',
          )}
        </p>
        <ul>
          <li>
            <span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details1.highlight',
            )}</span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details1.text',
            )}
          </li>
          <li>
            <span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details2.highlight',
            )}</span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details2.text',
            )}
          </li>
          <li>
            {$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details3.prefix',
            )}<span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details3.highlight',
            )}</span
            >{$i18n.t(
              'project.positioningAssistant.steps.introduction.instructions3.details3.suffix',
            )}
          </li>
        </ul>
      </div>
    </div>
  {/snippet}
</Modal>

<style lang="scss">
  .description {
    font-size: 0.75rem;
    line-height: 150%;
  }

  .steps {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    .step-item {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      gap: 0.25rem 1rem;
      flex-wrap: wrap;

      p {
        font-size: 0.75rem;
        font-weight: 600;
      }

      ul {
        grid-column: 2;

        li {
          list-style: disc;
          margin-left: 1rem;
          font-size: 0.75rem;
          color: var(--right-bar-muted-foreground);
          line-height: 150%;

          span {
            font-weight: 500;
            font-size: inherit;
          }
        }
      }
    }
  }
</style>
